import { Link } from "react-router-dom";
import {
  getStringFromList,
  getValueOrDash,
} from "../../../helpers/defaultReturnFunction";
import { impexDateFormat } from "../../../manager/dateManager";
import { dateType } from "./fields";
import DescriptionIcon from "@mui/icons-material/Description";
import { Badge } from "@mui/material";
import { Box } from "@mui/system";
import { getUser } from "../../../services/authService";
import ListIcon from "@mui/icons-material/List";

const invoiceTableCustomCell = ({
  handleDoubleClick,
  handleDeleteinvoice,
  cell,
  value,
  handlepopover,
  handlepopClick,
}) => {
  const user = getUser();

  const { original, getToggleRowExpandedProps } = cell.row;
  if (cell.value) {
    if (dateType.includes(cell.column.id)) {
      return impexDateFormat(cell.value);
    } else if (cell.column.id === "PartNo" && original?.subRows?.length > 1) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-around",
            ml: "5px",
          }}
          {...getToggleRowExpandedProps()}
        >
          <Box
            sx={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100px",
              overflow: "hidden",
              ml: -1,
            }}
          >
            {original?.subRows?.length
              ? getStringFromList(original?.PartNo)
              : cell.value}
          </Box>
          {original?.subRows?.length > 1 && (
            <Badge
              badgeContent={original?.subRows?.length}
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor: "#dceaff",
                  fontSize: "10px",
                },

                color: "#1d76ff",
              }}
            />
          )}
        </Box>
      );
    } else if (cell.column.id === "InvoiceNo" && user.isSystemAdmin) {
      return (
        <Box
          onClick={() => handleDoubleClick(original)}
          sx={{ color: "#0047ff" }}
        >
          {value}
        </Box>
      );
    } else return `${cell.value}`;
  } else {
    if (cell.column.id === "superaction") {
      const poid = cell.row.original.POID;
      const invoicenumber = cell.row.original.InvoiceNo;
      const originalrow = original;
      return (
        <ListIcon
          fontSize="small"
          onClick={(e) => {
            handlepopover(poid, invoicenumber, originalrow);
            handlepopClick(e);
          }}
        />
      );
    } else if (cell.column.id === "action") {
      return (
        <Link
          to={
            cell.row.original.InvoiceNo
              ? `${cell.row.original.POID}?inv=${cell.row.original.InvoiceNo}`
              : `${cell.row.original.POID}`
          }
        >
          <DescriptionIcon fontSize="small" />
        </Link>
      );
    }

    return `${getValueOrDash(cell.value)}`;
  }
};

export const invoiceDefaultColumn = {
  Cell: invoiceTableCustomCell,
};
